/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from 'helpers/store'
import { OffersAction } from 'store/offers/OffersAction'

import { Company } from 'types/entities/Company'
import ChangeCompanyModal from 'components/Companies/ChangeCompanyModal'

interface ChangeOfferCompanyModalProps {
    offerId: number
    sellerId: number
    initialCompany?: Company | null
    onSuccess?: () => void
}

const ChangeOfferCompanyModal: React.FC<ChangeOfferCompanyModalProps> = ({
    offerId,
    sellerId,
    initialCompany,
    onSuccess,
}) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const handleSave = async (selectedCompany: Company) => {
        await dispatch(
            OffersAction.updateOffer({
                id: offerId,
                seller_id: sellerId,
                company_id: Number(selectedCompany.id),
            })
        )
        if (onSuccess) onSuccess()
    }

    return (
        <ChangeCompanyModal
            className="ChangeOfferCompanyModal"
            title={t('Change Company') as string}
            subtitle={t('Select a new company for this offer') as string}
            initialCompany={initialCompany}
            onSave={handleSave}
        />
    )
}

export default ChangeOfferCompanyModal
